<template>
    <div class="page">
        <div class="top-header">
            <img class="logo" src="~@/assets/six-dimension-logo.png" alt="" />
            <div class="code-box">
                <span>
                    <span class="name">{{ stockName }}</span>
                    <span class="code">[{{ stockCode }}]</span>
                </span>
            </div>
        </div>
        <div class="container" v-if="!loading">
            <div class="time">
                - 最近30个交易日 -
            </div>
            <div class="item">
                <div class="title">
                    <img class="logo" src="~@/assets/bxzj-logo.png" alt="" />
                    <span>北向资金</span>
                </div>
                <div class="content">
                    <template v-if="stockHoldingsDiff">
                        期间北向资金持股量变动为<mark-num
                            :num="stockHoldingsDiff.holdStocksDiff"
                            unitType="STOCK"
                        ></mark-num
                        >，占流通股比例的<mark-num
                            :num="stockHoldingsDiff.calculateRatioDiff"
                            :isCalUnit="false"
                            unitType="%"
                        ></mark-num>
                        <div class="end-time" v-if="stockHoldingsDiff.endDate">
                            数据截至：{{
                                stockHoldingsDiff.endDate
                                    | formatterDate("MM月DD日")
                            }}
                        </div>
                    </template>
                    <template v-else>暂无数据</template>
                </div>
            </div>
            <div class="item">
                <div class="title">
                    <img class="logo" src="~@/assets/zldx-logo.png" alt="" />
                    <span>主力资金动向</span>
                </div>
                <div class="content">
                    <template v-if="mfdDataVO">
                        期间主力资金净{{
                            mfdDataVO.mfdInflowM >= 0 ? "流入" : "流出"
                        }}<mark-num
                            :num="mfdDataVO.mfdInflowM"
                            :isAbs="true"
                            unitType="MONEY"
                        ></mark-num>
                        ，总成交额<mark-num
                            :num="mfdDataVO.amt"
                            unitType="MONEY"
                        ></mark-num>
                        ，主力净{{
                            mfdDataVO.mfdInflowPerM >= 0 ? "流入" : "流出"
                        }}率<mark-num
                            :num="mfdDataVO.mfdInflowPerM"
                            :isAbs="true"
                            :isCalUnit="false"
                            unitType="%"
                        ></mark-num>
                        <div class="end-time" v-if="mfdDataVO.endDate">
                            数据截至：{{
                                mfdDataVO.endDate | formatterDate("MM月DD日")
                            }}
                        </div>
                    </template>
                    <template v-else>暂无数据</template>
                </div>
            </div>
            <div class="item">
                <div class="title">
                    <img class="logo" src="~@/assets/rzye-logo.png" alt="" />
                    <span>融资余额动向</span>
                </div>
                <div class="content">
                    <template v-if="mrgDataVO">
                        期间融资{{
                            mrgDataVO.mrgNetBuying >= 0 ? "净买入" : "净卖出"
                        }}额<mark-num
                            :num="mrgDataVO.mrgNetBuying"
                            :isAbs="true"
                            unitType="MONEY"
                        ></mark-num>
                        <div class="end-time" v-if="mrgDataVO.endDate">
                            数据截至：{{
                                mrgDataVO.endDate | formatterDate("MM月DD日")
                            }}
                        </div>
                    </template>
                    <template v-else>暂无数据</template>
                </div>
            </div>
            <div class="item">
                <div class="title">
                    <img class="logo" src="~@/assets/cgbh-logo.png" alt="" />
                    <span>高管、股东持股变化</span>
                </div>
                <div class="content">
                    <template v-if="mhdrDataVO">
                        期间最近一次公告日期{{
                            mhdrDataVO.announcementDate | formatterDate
                        }}，{{ mhdrDataVO.shareholderName
                        }}{{
                            mhdrDataVO.changeNumberSort >= 0 ? "增持" : "减持"
                        }}
                        <mark-num
                            :num="mhdrDataVO.changeNumberSort * 10000"
                            :isAbs="true"
                            unitType="STOCK"
                        ></mark-num
                        >，交易平均价<mark-num
                            :num="
                                (mhdrDataVO.changeNumberSort >= 0 ? 1 : -1) *
                                mhdrDataVO.averagePrice
                            "
                            :isAbs="true"
                            :isCalUnit="false"
                            unitType="元"
                        ></mark-num>
                    </template>
                    <template v-else>暂无数据</template>
                </div>
            </div>
            <div class="item">
                <div class="title">
                    <img class="logo" src="~@/assets/dzjy-logo.png" alt="" />
                    <span>大宗交易</span>
                </div>
                <div class="content">
                    <template v-if="btrDataVO">
                        期间最近一次公告日期{{
                            btrDataVO.tradeDate | formatterDate
                        }}，成交价<mark-num
                            :num="btrDataVO.price"
                            :isCalUnit="false"
                            unitType="元"
                        ></mark-num
                        >， 成交数量<mark-num
                            :num="btrDataVO.volume * 10000"
                            unitType="STOCK"
                        ></mark-num
                        >，较当日收盘价{{
                            btrDataVO.rateDiscount >= 0 ? "溢价率" : "折价率"
                        }}
                        <mark-num
                            :num="btrDataVO.rateDiscount"
                            :isCalUnit="false"
                            :isAbs="true"
                            unitType="%"
                        ></mark-num>
                    </template>
                    <template v-else>暂无数据</template>
                </div>
            </div>
            <div class="item">
                <div class="title">
                    <img class="logo" src="~@/assets/jgdy-logo.png" alt="" />
                    <span>机构调研</span>
                </div>
                <div class="content">
                    <template v-if="rsbsDataVO">
                        期间共有
                        <mark-num
                            :num="rsbsDataVO.investCount"
                            :floatPlaceNum="0"
                        ></mark-num>
                        批机构调研，合计调研的机构家数
                        <mark-num
                            :num="rsbsDataVO.investigationAllInsCount"
                            :floatPlaceNum="0"
                        ></mark-num>
                        家，其中证券公司
                        <mark-num
                            :num="rsbsDataVO.investigationSeCount"
                            :floatPlaceNum="0"
                        ></mark-num>
                        家、基金公司
                        <mark-num
                            :num="rsbsDataVO.investigationFundCount"
                            :floatPlaceNum="0"
                        ></mark-num>
                        家、保险及保险资管公司
                        <mark-num
                            :num="rsbsDataVO.investigationInsuranceCount"
                            :floatPlaceNum="0"
                        ></mark-num>
                        家、私募
                        <mark-num
                            :num="rsbsDataVO.investigationPriCount"
                            :floatPlaceNum="0"
                        ></mark-num>
                        家、其他
                        <mark-num
                            :num="rsbsDataVO.investigationOtherCount"
                            :floatPlaceNum="0"
                        ></mark-num>
                        家。
                    </template>
                    <template v-else>暂无数据</template>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped src="./stock-six-dimension.scss">
</style>

<script>
import stockSixDimensionService from "../../service/stock-six-dimension.service";
import markNum from "./mark-num.vue";
export default {
    name: "stock-six-dimension",
    components: {
        "mark-num": markNum,
    },
    filters: {
        formatterDate(date, formatter = "YYYY年MM月DD日") {
            let y = new Date(date).getFullYear();
            let m = new Date(date).getMonth() + 1;
            let d = new Date(date).getDate();
            return formatter
                .replace("YYYY", y)
                .replace("MM", m)
                .replace("DD", d);
        },
    },
    data() {
        return {
            stockName: undefined,
            stockCode: undefined,
            loading: true,
            wan: 10000,
            yi: 100000000,
            stockHoldingsDiff: {
                // 北上资金
                calculateRatioDiff: 0,
                holdStocksDiff: 0,
                holdStocksDiffCnt: 0,
                endDate: 0,
            },
            mfdDataVO: {
                //主力资金
                mfdInflowM: 0,
                amt: 0,
                mfdInflowPerM: 0,
                endDate: 0,
            },
            mrgDataVO: {
                //融资余额
                mrgNetBuying: 0,
                endDate: 0,
            },
            mhdrDataVO: {
                // 高管、股东持股
                announcementDate: 0,
                shareholderName: undefined,
                averagePrice: 0,
                changeNumberSort: 0,
            },
            btrDataVO: {
                // 大宗交易
                tradeDate: 0,
                price: 0,
                volume: 0,
                rateDiscount: 0,
            },
            rsbsDataVO: {
                // 机构调研
                investCount: 0,
                investigationAllInsCount: 0,
                investigationSeCount: 0,
                investigationFundCount: 0,
                investigationInsuranceCount: 0,
                investigationPriCount: 0,
                investigationOtherCount: 0,
            },
        };
    },
    created() {
        let routeParams = this.$route.query;
        this.stockName = routeParams.stockName;
        this.stockCode = routeParams.stockCode;
        stockSixDimensionService
            .calSingleResonance(this.stockCode)
            .then((res) => {
                this.stockHoldingsDiff = res.data.stockHoldingsDiff;
                this.mfdDataVO = res.data.mfdDataVO;
                this.mrgDataVO = res.data.mrgDataVO;
                this.mhdrDataVO = res.data.mhdrDataVO;
                this.btrDataVO = res.data.btrDataVO;
                this.rsbsDataVO = res.data.rsbsDataVO;
                this.loading = false;
            });
    },
};
</script>